<template>
    <path d="M7.908 4.142c-2.032-.015-4.04.754-5.529 2.233C1.271 7.478.622 8.571.243 9.975c-.19.698-.22.981-.219 2.04.002 1.366.111 1.943.584 3.064 1.013 2.406 3.352 4.253 5.979 4.723.637.113 2.28.047 3.04-.123.763-.171 2.194-.832 2.91-1.344 1.054-.754 1.965-1.915 2.54-3.24.16-.366.313-.743.34-.836.17-.572.305-1.757.307-2.69l.001-1.081-3.917.022-3.918.022-.023 1.461c-.018 1.136 0 1.463.085 1.47.059.004 1.108 0 2.331-.008 1.223-.009 2.223.003 2.223.027 0 .142-.382.892-.666 1.307-.837 1.225-2.164 1.958-3.78 2.09-.565.045-.8.021-1.41-.145-1.182-.322-2.212-1.048-2.856-2.012a4.875 4.875 0 0 1-.311-4.857c1.211-2.45 4.113-3.426 6.552-2.201.404.203.76.369.793.369.031 0 .446-.514.921-1.142l.864-1.142-.201-.169c-.111-.093-.528-.34-.927-.548a7.846 7.846 0 0 0-3.577-.89zm11.93 4.601v2.266H17.57v1.873h2.266v2.266h1.873v-2.266h2.266v-1.873H21.71V8.743z"/>
</template>

<script>
    export default {
        name: 'google-plus-big',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/GooglePlusBig.vue